import { Pipe, PipeTransform } from '@angular/core';
import { DiscountTypeDto } from '@up/data';

@Pipe({
  name: 'orderAvailableVouchers'
})
export class OrderAvailableVouchersPipe implements PipeTransform {

  transform(discountTypes: DiscountTypeDto[], ...args: unknown[]): unknown {
    if(!discountTypes) return [];
    
    return discountTypes?.filter(discount => discount.enabled && discount.voucherCode && discount.useVoucherCode);
  }

}
